import React, { memo, useCallback } from 'react';
import { CorporateToggleContainer } from '../styled/Header.styled';
import LabelledToggle from './LabelledToggle';
import { useCorporateMode, usePreloading } from '../../contexts/SiteContext';

const CorporateToggleComponent = memo(() => {
  const { isCorporateMode, toggleCorporateMode } = useCorporateMode();
  const { isPreloading } = usePreloading();

  const handleToggle = useCallback(() => {
    if (isPreloading) {
      return;
    }
    toggleCorporateMode();
  }, [isPreloading, toggleCorporateMode]);

  return (
    <CorporateToggleContainer>
      <LabelledToggle
        isActive={isCorporateMode}
        onToggle={handleToggle}
        offLabel="NWC"
        onLabel="CORPORATE MODE"
        ariaLabel="Toggle corporate mode"
      />
    </CorporateToggleContainer>
  );
});

CorporateToggleComponent.displayName = 'CorporateToggleComponent';

export default CorporateToggleComponent;
